import React from "react";
import { TableCell, TableRow } from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: {
    color: blueGrey[600],
  },
});

function OrderDetailsList({ items, currentPage, pageSize }) {
  const classes = useStyles();
  const endIndex =
    pageSize === -1 ? items.length : currentPage * pageSize + pageSize;

  return (
    <React.Fragment>
      {items.slice(currentPage * pageSize, endIndex).map((item) => (
        <TableRow key={item.itemNumber}>
          <TableCell>
            <Typography className={classes.root} variant="body2">
              {item.itemCode}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.root} variant="body2">
              {item.description}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.root} variant="body2">
              {(item.quantity * 1).toFixed(0)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.root} variant="body2">
              {"$" + (item.price * 1).toFixed(2)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.root} variant="body2">
              {"$" + (item.itemTotal * 1).toFixed(2)}
            </Typography>
          </TableCell>
        </TableRow>
      ))}
    </React.Fragment>
  );
}

export default OrderDetailsList;
